module.exports = __webpack_public_path__ + "img/iskolafejlesztes-1.303d0a47.jpg";